export const formatDate = simpleDate => {
  let date = new Date(simpleDate);
  let dd = formatValue(date.getDate());
  let mm = formatValue(date.getMonth() + 1);
  let yy = date.getFullYear().toString();
  return mm + "/" + dd + "/" + yy;
};

export const formattedDateForEdit = simpleDate => {
  let date = new Date(simpleDate);
  let dd = formatValue(date.getDate());
  let mm = formatValue(date.getMonth() + 1);
  let yyyy = date.getFullYear();
  return [yyyy, mm, dd].join("-");
};

export const getFullDateTime = (simpleDate, length = 12) => {
  let date = new Date(simpleDate);
  let dd = formatValue(date.getDate());
  let mm = formatValue(date.getMonth() + 1);
  let yy = date
    .getFullYear()
    .toString()
    .slice(-2);
  let hh = formatValue(date.getHours());
  let min = formatValue(date.getMinutes());
  let ss = formatValue(date.getSeconds());
  return [yy, mm, dd, hh, min, ss]
    .join("")
    .toString()
    .substring(0, length);
};

function formatValue(value) {
  return value < 10 ? "0" + value : value;
}

export const calculateDays = timeDif => {
  let days = Math.round(timeDif / (1000 * 60 * 60 * 24));
  return days;
};



// WEBPACK FOOTER //
// ./src/utils/DateFormatter.js